import {Component, Inject} from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import {IdexService} from 'app/idex.service';

@Component({
   selector: 'app-change-pass-sign',
   templateUrl: './change-pass-sign.component.html',
   styleUrls: ['./change-pass-sign.component.css']
})
export class ChangePassSignComponent {
   errorMessage: string;
   error_duplicate = false;
   error_match = false;

   constructor(@Inject(MAT_DIALOG_DATA) private data: any, public service: IdexService) {
   }

   changePasswordSign(oldpwd: any, newpwd: any, conpwd: any) {
      const oldpw = oldpwd.value;
      const newpw = newpwd.value;
      const conpw = conpwd.value;
      if (newpw === conpw && oldpw !== newpw && newpw.length >= 6 && conpw.length >= 6) {
         this.error_duplicate = false;
         this.error_match = false;

      } else if (oldpw === newpw && newpw === conpw) {
         this.data.translate.get('changePassword.psw_duplicate').subscribe(s => {
            this.errorMessage = s;
         });
         newpwd.focus();
      } else {
         this.data.translate.get('changePassword.psw_match').subscribe(s => {
            this.errorMessage = s;
         });
         newpwd.focus();
      }
   }

}
